export class Group {
    groupId: string;
    groupName: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/group.ts